/**
 * @enum{string}
 */
export const RecordingStatus = {
  BEFORE_RECORDING: 'beforeRecording',
  RECORDING: 'recording',
  LOADING: 'loading',
  RECORDED: 'recorded',
};
/**
 * @enum{string}
 */
export const PreviewStatus = {
  PAUSE: 'pause',
  PLAY: 'play',
};
